import { useCallback } from 'react'
import { createContext, useState } from 'react'
import { fetchUserFunctions } from '../Api/dashboard'
import { fetchAllUserTags } from '../Api/transcriptAndSummary'
import { useEffect } from 'react'

export const NavbarContext = createContext({
  isNavbarOpen: false,
  toggleNavbar: undefined,
  currentPath: ['transcripts-summaries'],
  dashboardFunctions: [],
  dashboardTags: [],
  recurringEvents: [],
  searchIsOpen: false,
  setSearchIsOpen: undefined,
})

const NavbarContextProvider = ({children}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [currentPath, setCurrentPath] = useState(['transcripts-summaries'])
  const [dashboardFunctions, setDasboardFunctions] = useState([])
  const [dashboardTags, setDashboardTags] = useState()
  const [recurringEvents, setRecurringEvents] = useState([])

  const [searchIsOpen, setSearchIsOpen] = useState(false)

  const fetchUserFunctionsData = useCallback(async () => {
    const apiResponse = await fetchUserFunctions()
    if (apiResponse?.length > 0) {
      setDasboardFunctions([...apiResponse.map(item => ({name: item, id: item.replace(' ', '-')}))])
    } else {
      setDasboardFunctions([])
    }
  }, [])
 
  const fetchUserTagsData = useCallback(async () => {
    const apiResponse = await fetchAllUserTags()
    if (apiResponse?.tags) {
      setDashboardTags([...apiResponse.tags.map(({id, name}) => ({name, id: `tag-${id}`}))])
    } else {
      setDashboardTags([])
    }
    
    if (apiResponse?.recurringEvents) {
      setRecurringEvents([...apiResponse.recurringEvents.map(({id, name}) => ({name, id: `tag-${id}`}))])
    }
  }, [])

  useEffect(() => {
    fetchUserFunctionsData()
    fetchUserTagsData()
  }, [])

  const navbarContextValue = {
    isNavbarOpen: isOpen,
    toggleNavbar: () => setIsOpen(!isOpen),
    currentPath,
    setCurrentPath,
    dashboardFunctions,
    dashboardTags,
    recurringEvents,
    searchIsOpen,
    setSearchIsOpen,
  }

  return (
    <NavbarContext.Provider value={navbarContextValue}>
      {children}
    </NavbarContext.Provider>
  )
}

export default NavbarContextProvider